import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import React, { FC } from 'react';
import { UploadOne } from '@im/ui-lib/zenith/icons';
import useSnackBar from 'src/hooks/useSnackBar';
import { useGetExcelReport } from '../hooks/ingramProgramsMutations';
import { downloadFile } from 'src/util/downloadFileUtil';

export interface ExportComponentProps {
  isProgramOrDiscount: boolean;
  params: any;
}

const ExportComponent: FC<ExportComponentProps> = ({
  isProgramOrDiscount,
  params,
}) => {
  const translate = useTranslate();
  const { showSnackBar } = useSnackBar();

  const downloadExcelReport = useGetExcelReport(isProgramOrDiscount, params);

  const handleDownloadExcel = () => {
    showSnackBar({
      autoHide: 'stay',
      message: translate('Common.Downloading'),
      severity: 'info',
    });
    downloadExcelReport
      .mutateAsync()
      .then((response) => {
        downloadFile(
          response,
          `${isProgramOrDiscount ? 'Program' : 'Discount'}_Report.xlsx`
        );
        showSnackBar({
          autoHide: 2000,
          message: translate('Common.DownloadSuccess'),
          severity: 'success',
        });
      })
      .catch(() => {
        showSnackBar({
          autoHide: 2000,
          message: translate('Common.DownloadError'),
          severity: 'error',
        });
      });
  };

  return (
    <Button
      onClick={handleDownloadExcel}
      startIcon={<UploadOne />}
      variant="newOutlined"
    >
      {translate('Common.Export')}
    </Button>
  );
};

export default ExportComponent;
